import { render, staticRenderFns } from "./ConfigSistemaNova.vue?vue&type=template&id=b20056c2"
import script from "./ConfigSistemaNova.vue?vue&type=script&lang=js"
export * from "./ConfigSistemaNova.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports